'use client';

import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

const FormSalesManagoForms = ({ blok }) => {
  // Tailwind CSS classes --- --- --- --- --->
  const formWidth = {
    '50%': 'col-span-12 sm:col-span-6',
    '66%': 'col-span-12 sm:col-span-6 md:col-span-9',
    '100%': 'col-span-12',
  };

  return (
    <div
      className={`relative flex flex-col items-center ${
        formWidth[blok.form_width]
      } px-2 py-6 sm:px-4`}
      {...storyblokEditable(blok)}
    >
      <iframe
        className="w-full h-auto flex flex-col items-center justify-center"
        src={blok.salesmanago_link}
        style={{ height: `${blok.iframe_height}px` }}
        title={blok._uid}
      />
    </div>
  );
};

export default FormSalesManagoForms;
